export default __webpack_public_path__ + "static/N0128-7cd7e0d07a9dca013cf690ec2f6f5b9b.png";